import React from 'react';
import {APP_Version} from './AppConstants.js'
import { connect } from 'react-redux';

import img from 'Common/img/BCI Logo.png'
import nextId from "react-id-generator";
import { setPrefix } from "react-id-generator";



export default class AppServiceHealth extends React.Component {
      
  componentDidMount() {
    document.title = "Next-GenProservice";
  }
        
 render() {
   console.log('HImmmm');
    
   var verison = '';
  return(
  
  <div className='Health'>
   
   <table width='990px' align="center" >
     <tbody>
       <tr>
 
   <td>Services are  up and running and current App Version is : {verison}
      </td>
   </tr>
   
  </tbody>
  </table>
 
   </div>


  );
}
}

